import { render, staticRenderFns } from "./bscContactPerson.vue?vue&type=template&id=a262cf34&scoped=true"
import script from "./bscContactPerson.vue?vue&type=script&lang=js"
export * from "./bscContactPerson.vue?vue&type=script&lang=js"
import style0 from "./bscContactPerson.vue?vue&type=style&index=0&id=a262cf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a262cf34",
  null
  
)

export default component.exports